module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Error-circle-b1a3753add2aa99671eae9f5bd0c6b21.svg";